export default "__VITE_ASSET__rRK9ATMq__"